const urlEnum = Object.freeze({
  URL_CERTI: 'https://monitoraplicaciones.sappcerti.sgtiad.net/api',
  URL_PRE: 'https://monitoraplicaciones.sappcerti.sgtiad.net/api',
  URL_PRO: 'https://monitoraplicaciones.sappcerti.sgtiad.net/api',
});

const envEnum = Object.freeze({
  CERTI: 'certi',
  PRE: 'pre',
  PRO: 'pro',
});


export const baseUrl = {
  [envEnum.CERTI]: urlEnum.URL_CERTI,
  [envEnum.PRE]: urlEnum.URL_PRE,
  [envEnum.PRO]: urlEnum.URL_PRO,
}